import React from 'react';

const ErrorDisplay = ({ error }) => {
  if (!error || !error.message) return null;

  return (
    <div className={"mls-o-error"}>
      <p>
        {error.message}
      </p>
    </div>
  );
};

export default ErrorDisplay;
